import Button, { ButtonProps } from "shared/Button/Button";
import React from "react";

export interface ButtonPrimaryProps extends ButtonProps {}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  className = "",
  icon = false,
  ...args
}) => {
  return (
    <Button
      className={`button-primary disabled:bg-opacity-70 bg-main hover:bg-mainHover text-white flex gap-6 ${className}`}
      icon
      {...args}
    />
  );
};

export default ButtonPrimary;
